<template>
    <setup_content title="Формирование типового (эталонного) объекта недвижимости">
        <factors :controller="controller" />

        <div class="element-row mb-3">
            <label class="element-row_label">Выбор способа формирования</label>
            <div class="element-row_fields">
                <b-form-radio-group v-model="selection_type" :options="options" :disabled="!controller.check_roles([ 'model' ])" />
            </div>
        </div>

        <cad_num v-if="selection_type === 'По кадастровому номеру'" :controller="controller" />

        <elements
			v-if="controller.group_id && selection_type === 'Поиск' && elements_attrs"
			ref="objects"
            :attrs="elements_attrs"
			service="cadastral_objects"
			:postfix_for_storage_name="'_reference_' + controller.id"
			without_add
			:raw_query="{ group : controller.group_id }"
            :additional_query="{ 'current_version.attrs.Area' : { '$exists' : true } }"
			not_able_for_delete
			with_filters
			essence_name_genetive_case="объекта-аналога"
			essence_name_for_plural_1="объект-аналог"
			essence_name_for_plural_234="объекта-аналога"
			essence_name_for_plural_others="объектов-аналогов"
			without_back_button
            without_export
			initial_per_page="5"
			initial_sort_by="system.reference_weighted"
			:initial_sort_desc="false"
			elements_table_height="25vh"
			:with_show_attrs="false"
        >

			<template v-slot:title>

				<h4>Выбор объекта в качестве типового (эталонного) объекта недвижимости</h4>

			</template>

            <template v-slot:table_head_params="head_data">
                <div class="d-flex" style="gap: 8px;">
                    <span style="flex: 1">{{ head_data.data.label }}</span>
                    <div v-b-tooltip:fullscreen.hover.bottomright title="Рассчитывается как Эвклидово расстояние"><base-icon name="info" /></div>
                </div>
            </template>

            <template v-slot:table_cell_params="cell_data">

                <b-form-radio v-if="cell_data.data.field.key == 'options'" style="z-index: 0;"
                    v-model="search_object_id" :value="cell_data.data.item.id"
                />

            </template>

		</elements>

        <predicted v-if="selection_type === 'Гипотетический'" :data="predicted" @set_value="(value) => this.controller.set_field('predicted', value)" />
    </setup_content>
</template>

<script>
import setup_content from "../../setup_assets/content"
import elements from "../../../../../elements"
import factors from "../factors"
import predicted from "./predicted"
import cad_num from "./cad_num"
import Reference_controller from "../controller"

export default {
    props :
	{
        controller : Reference_controller,
	},

    components :
    {
        setup_content,
        elements,
        factors,
        predicted,
        cad_num
    },

    data()
    {
        return {
            attrs : null,
            elements_attrs : null,
            options: [ 'По кадастровому номеру', 'Поиск', 'Гипотетический' ],

            selection_type : this.controller.data.selection_type,
            search_object_id : this.controller.data.search_object_id,
            additional_query : null,

            predicted : []
        }
    },

    beforeMount()
    {
        this.controller.set_elements_attrs((attrs) => {
            this.elements_attrs = attrs

            if (this.$refs.objects)
            {
                this.elements_attrs = null

                this.$nextTick(() => {
                    this.elements_attrs = attrs
                })
            }
        })

        this.controller.set_predicted((predicted) => this.predicted = predicted)
    },

    watch :
    {
        selection_type(value)
        {
            this.controller.change_selection_type(value)
        },

        search_object_id(value)
        {
            this.controller.set_field("search_object_id", value)
        }
    },
}
</script>
